module.exports = __webpack_public_path__ + "static/media/calculator.2a9fcba8.svg";